import dashboardTypes from '../types/dashboard'

export const setFilters = (filter) => {
  return { type: dashboardTypes.SET_FILTERS, payload: filter }
}
export const setUsageFilters = (filter) => {
  return { type: dashboardTypes.SET_USAGEFILTERS, payload: filter }
}

export const setTableFilters = (filter) => {
  return { type: dashboardTypes.SET_TABLE_FILTERS, payload: filter }
}
export const clearFilters = () => ({
  type: dashboardTypes.CLEAR_FILTERS,
})
export const setDownload = (data) => {
  return { type: dashboardTypes.SET_DOWNLOAD, payload: data }
}
export const setLoading = (data) => {
  return { type: dashboardTypes.SET_LOADING, payload: data }
}